export interface Trait {
  name: string;
  level: 1 | 2 | 3 | 4 | 5;
  icon: string;
}

export interface Breed {
  id: string;
  name: string;
  petType: string;
  description: string;
  origin: string;
  idealEnvironment: string;
  image: string;
  size: 'small' | 'medium' | 'large';
  energyLevel: 'low' | 'medium' | 'high';
  apartmentFriendly: boolean;
  familyFriendly: boolean;
  traits: Trait[];
  care: {
    exerciseNeeds: string;
    groomingRequirements: string;
    spaceRequirements: string;
    timeCommitment: string;
  };
  health: {
    commonRisks: string[];
    preventativeCare: string[];
    vetFrequency: string;
    lifespan: string;
  };
  bestFor: string[];
}

export interface PetType {
  id: string;
  name: string;
  emoji: string;
  description: string;
  color: string;
}

// Dataset used by the in-app "Know Your Pet" route.
// Kept self-contained (no dependency on the marketing website repo).
import datasetDogCat from './dataset.dog-cat.json';
import datasetOther from './dataset.other.json';

type DatasetShape = {
  petTypes: PetType[];
  breeds: Breed[];
};

const datasetDogCatTyped = datasetDogCat as unknown as DatasetShape;
const datasetOtherTyped = datasetOther as unknown as DatasetShape;

export const petTypes: PetType[] = [
  ...datasetDogCatTyped.petTypes,
  ...datasetOtherTyped.petTypes,
];

export const breeds: Breed[] = [
  ...datasetDogCatTyped.breeds,
  ...datasetOtherTyped.breeds,
];
